goog.provide("shadow.js.shim.module$$flows$js");
goog.provide("module$shadow_js_shim_module$$flows$js");
shadow.js.shim.module$$flows$js = shadow.js.nativeProvides["@flows/js"] = shadow$bridge("@flows/js");
module$shadow_js_shim_module$$flows$js.default = shadow.js.shim.module$$flows$js;
